import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createUnit,
  fetchAllUnits,
  updateUnit,
  fetchOneUnit,
  deleteUnit,
} from "services/unit";

// Fetch all units with optional filtering
export const useAllUnits = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["units", filters],
    queryFn: () => fetchAllUnits(filters),
    enabled,
  });
};

// Fetch single unit by ID
export const useOneUnit = (id, enabled = true) => {
  return useQuery({
    queryKey: ["unit", id],
    queryFn: () => fetchOneUnit(id),
    enabled: Boolean(id) && enabled,
  });
};

// Create new unit
export const useCreateUnit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createUnit(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["units"] });
    },
  });
};

// Update existing unit
export const useUpdateUnit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateUnit({ id, data }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["units"] });
      queryClient.invalidateQueries({ queryKey: ["unit", variables.id] });
    },
  });
};

// Delete unit
export const useDeleteUnit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteUnit(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["units"] });
      queryClient.invalidateQueries({ queryKey: ["unit", id] });
    },
  });
};
